import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader, Card, Btn, Icon } from "@/components/kit";

const timeAgo = (iso) => {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 3600) return `${Math.max(1, Math.floor(s / 60))}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
const ROUTE = { lead: "/app/leads", sip: "/app/clients", task: "/app/tasks", regulatory: "/app/regulatory", market: "/app/market", appointment: "/app/appointments" };

export default function Notifications() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const open = async (n) => {
    if (!n.read) { setItems((xs) => xs.map((x) => (x.id === n.id ? { ...x, read: true } : x))); await api.post(`/notifications/${n.id}/read`); }
    nav(ROUTE[n.type] || "/app");
  };
  const readAll = async () => { setItems((xs) => xs.map((x) => ({ ...x, read: true }))); await api.post("/notifications/read-all"); };
  const unread = items.filter((x) => !x.read).length;

  return (
    <div className="fade-up">
      <PageHeader demo={false} title="Notifications" subtitle="Your smart alert hub — leads, SIP failures, tasks, regulatory & market events." icon="Bell" color="#F97316"
        action={unread > 0 && <Btn variant="outline" onClick={readAll} data-testid="notif-read-all"><Icon name="CheckCheck" size={15} /> Mark all read</Btn>} />

      <div className="space-y-2 max-w-3xl" data-testid="notifications-list">
        {items.length === 0 && <div className="text-center text-gray-400 py-16"><Icon name="BellOff" size={30} className="mx-auto mb-2 text-gray-300" />You're all caught up.</div>}
        {items.map((n) => (
          <button key={n.id} onClick={() => open(n)} data-testid={`notif-${n.type}`}
            className={`w-full text-left card-mfx p-4 flex items-start gap-3 hover-lift ${!n.read ? "border-l-4" : "opacity-75"}`} style={!n.read ? { borderLeftColor: n.color } : {}}>
            <div className="w-9 h-9 rounded-xl grid place-items-center shrink-0" style={{ background: `${n.color}18` }}><Icon name={n.icon} size={17} style={{ color: n.color }} /></div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2"><span className="font-semibold text-sm">{n.title}</span>{!n.read && <span className="w-2 h-2 rounded-full shrink-0" style={{ background: n.color }} />}</div>
              <p className="text-sm text-gray-600 mt-0.5 leading-relaxed">{n.body}</p>
              <span className="text-[11px] text-gray-400">{timeAgo(n.ts)}</span>
            </div>
            <Icon name="ChevronRight" size={16} className="text-gray-300 mt-1 shrink-0" />
          </button>
        ))}
      </div>
    </div>
  );
}
